/**
 * Countries Store
 * Manages countries data for filters
 */

import { create } from 'zustand';
import { fetchCountries } from '../services/countries.service';
import { globalConfig } from '../config/globalConfig';
import type { Country } from '../interfaces/apiInterfaces/countries';

interface CountriesStore {
  countries: Country[];
  isLoading: boolean;
  error: string | null;
  load: () => Promise<void>;
  reset: () => void;
}

export const useCountriesStore = create<CountriesStore>((set) => ({
  // Initial State
  countries: [],
  isLoading: false,
  error: null,

  // Actions
  load: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await fetchCountries({ page_size: globalConfig.defaultPageSize });
      set({ countries: response.data, isLoading: false });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to load countries';
      set({ error: message, isLoading: false });
      console.error('Failed to load countries:', error);
    }
  },

  reset: () => set({ countries: [], isLoading: false, error: null }),
}));
